import { render } from "./PatientInformation.vue?vue&type=template&id=419af43a"
import script from "./PatientInformation.vue?vue&type=script&lang=js"
export * from "./PatientInformation.vue?vue&type=script&lang=js"

import "./PatientInformation.vue?vue&type=style&index=0&id=419af43a&lang=css"

import exportComponent from "/vercel/path0/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/cases/PatientInformation.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "419af43a"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('419af43a', __exports__)) {
    console.log('reload')
    api.reload('419af43a', __exports__)
  }
  
  module.hot.accept("./PatientInformation.vue?vue&type=template&id=419af43a", () => {
    console.log('re-render')
    api.rerender('419af43a', render)
  })

}


export default __exports__